// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__CNX92","contentWrapper":"styles_contentWrapper__gfjjT"};